module.exports = __webpack_public_path__ + "static/media/336x280.373f7258.png";